import { forwardRef } from "react";
import classNames from "classnames";
import { type MediasVariant } from "./MediasLogo";
import { userIsPublic, userIsRegistered, userIsSalesman } from "../../../utils/roles";

import classes from "./HeaderCircle.module.less";

type HeaderCircleProps = Omit<JSX.IntrinsicElements["div"], "ref">;

/*
  Circular background element used for the user avatar and order type icons
 */
export const HeaderCircle = forwardRef<HTMLDivElement, HeaderCircleProps>(({ className, ...rest }, ref) => {
  const cls = classNames(classes.root, className);
  return <div className={cls} ref={ref} {...rest} />;
});

type UserHeaderCircleProps = HeaderCircleProps & {
  variant: Exclude<MediasVariant, "plus-business">;
};

const VARIANT_CLS = {
  general: classes.userAnon,
  plus: classes.userPlus,
  business: classes.userBusiness,
  growth: classes.userBusiness,
};

export const UserHeaderCircle = forwardRef<HTMLDivElement, UserHeaderCircleProps>(
  ({ variant, className, ...rest }, ref) => {
    const cls = classNames(VARIANT_CLS[variant], className);
    return <HeaderCircle className={cls} ref={ref} {...rest} />;
  },
);

export const getMediasVariant = () => {
  // Anonymous - logged out. Go public - logged out when go public is enabled.
  if (userIsPublic()) {
    return "general";
  } else if (userIsRegistered()) {
    return "plus";
  } else if (userIsSalesman()) {
    return "growth";
  } else {
    return "business";
  }
};
